"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cootsWidth = 21;
exports.default = cootsWidth;
